import React from "react";
import PropTypes from "prop-types";

import embedConfig from "components/content-blocks/embed/config";

const ContentBlocker = ({ onButtonClick }) => (
  <div className="embed-blocker">
    <div className="embed-blocker__content">
      <div className="embed-blocker__message">{embedConfig.message}</div>
      <button
        type="button"
        className="embed-blocker__btn btn is-default"
        onClick={onButtonClick}
      >
        Cookies aanpassen
      </button>
    </div>
  </div>
);

ContentBlocker.propTypes = {
  onButtonClick: PropTypes.func.isRequired,
};

export default ContentBlocker;
